module.exports = __webpack_public_path__ + "img/index_yewu_icon_chengsh.8f306519.png";